import type { GanttFornecedorBarraObraProps } from "./types-gantt-fornecedor-barra-obra";
import { GanttFornecedorBarraObraView } from "./view-gantt-fornecedor-barra-obra";

/** Barra da obra (agrupamento por Obra): linha fina com datas e "Obra" acima e a pílula de duração. */
export function GanttFornecedorBarraObra(props: GanttFornecedorBarraObraProps) {
  return <GanttFornecedorBarraObraView {...props} />;
}

export type * from "./types-gantt-fornecedor-barra-obra";
